export interface Budget {
    ground: number
    structure: number
    hot: number
    live: number
}

export type Vec3 = [number, number, number]

export type Rgb = [number, number, number]

export interface FramePose {
    x: number
    y: number
    z: number
    rx: number
    ry: number
    rz: number
    w: number
    h: number
}

export interface ShapeCamera {
    pitch: number
    distance: number
    targetY: number
}

export interface ShapeData<TExtra = unknown> {
    key: string
    budget: Budget
    count: number
    positions: Float32Array
    colors: Uint8Array
    meta: Float32Array
    anchors: Record<string, Vec3>
    frame: FramePose
    camera: ShapeCamera
    radius: number
    height: number
    extra?: TExtra
}

export const KIND_GROUND = 0
export const KIND_STRUCTURE = 1
export const KIND_HOT = 2
export const KIND_LIVE = 3

export const HOME_BUDGET: Budget = {
    ground: 24000,
    structure: 91760,
    hot: 3000,
    live: 1240
}

export const budgetTotal = (budget: Budget): number => budget.ground + budget.structure + budget.hot + budget.live

export const categoryStarts = (budget: Budget): [number, number, number, number] => [
    0,
    budget.ground,
    budget.ground + budget.structure,
    budget.ground + budget.structure + budget.hot
]

export const categorySizes = (budget: Budget): [number, number, number, number] => [
    budget.ground,
    budget.structure,
    budget.hot,
    budget.live
]

export const scaleBudget = (budget: Budget, factor: number): Budget => ({
    ground: Math.max(64, Math.round(budget.ground * factor)),
    structure: Math.max(256, Math.round(budget.structure * factor)),
    hot: Math.max(64, Math.round(budget.hot * factor)),
    live: Math.max(64, Math.round(budget.live * factor))
})
